@if (apoderados().length > 0) {
  <div class="card" style="margin-bottom: 3rem;">
    <table class="table is-fullwidth is-striped is-hoverable" aria-label="Apoderados">
      <thead>
        <tr>
          <th scope="col">Nombre</th>
          <th scope="col">NIF</th>
          <th scope="col">Tipo de poder</th>
          <th scope="col">Fecha de alta</th>
          <th scope="col">Fecha de baja</th>
        </tr>
      </thead>
      <tbody>
        @for (apoderado of apoderados(); track apoderado.nif + apoderado.nombre) {
          <tr
            class="is-clickable"
            tabindex="0"
            (click)="onRowClick(apoderado)"
            (keydown)="onRowKeydown($event, apoderado)"
          >
            <td>{{ apoderado.nombre }}</td>
            <td>{{ apoderado.nif }}</td>
            <td>{{ apoderado.tipoPoder }}</td>
            <td>{{ apoderado.fechaAlta || '—' }}</td>
            <td>{{ apoderado.fechaBaja || '—' }}</td>
          </tr>
        }
      </tbody>
    </table>
  </div>
} @else {
  <p class="cr-empty">Sin apoderados registrados.</p>
}
